module.exports = __webpack_public_path__ + "img/NA.fcb4b70b.svg";